export const iconFontAwesomeArrowsCaretLeft = (
	<i className="fa-solid fa-caret-left"></i>
);
